import { Button, Stack, useTheme } from '@mui/material';

interface TabsFieldProps {
  disabled: boolean;
  value: string;
  onChange: (value: string) => void;
  name: string;
  tabQuantity: number;
  label: string;
}

export const TabsField = ({ disabled, value, onChange, tabQuantity, label }: TabsFieldProps) => {
  const theme = useTheme();

  return (
    <>
      <Stack
        data-cy-field-type="tabs"
        direction="row"
        justifyContent="space-between"
        gap={1}
        p={1}
        sx={{ backgroundColor: (theme) => theme.palette.grey[50], borderRadius: '9px' }}
      >
        {Array.from({ length: tabQuantity }).map((_, index) => {
          const buttonIsActive = parseInt(value) === index + 1;
          return (
            <Button
              key={index}
              variant="outlined"
              color={buttonIsActive ? 'primary' : 'secondary'}
              fullWidth
              disabled={disabled}
              sx={buttonIsActive ? theme.mixins.activeButton : { backgroundColor: theme.palette.primary.contrastText }}
              onClick={() => onChange((index + 1).toString())}
            >
              {label} {index + 1}
            </Button>
          );
        })}
      </Stack>
    </>
  );
};

export default TabsField;
